<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" :width="size" :height="size" viewBox="0 0 16 16">

        <g transform="translate(2 1.5) scale(0.8)" fill="white" class="TQ_Animation_fadeInLeft">
            <path fill="white" d="M2 13h2l5-5-5-5h-2l5 5z"></path>
            <path fill="white" d="M7 13h2l5-5-5-5h-2l5 5z"></path>
        </g>

    </svg>
</template>

<script>
    export default {
        name: "si_arrowRight",
        props:{
            size:{
                type: String,
                default: '48px'
            },
            direction:{
                type: String,
                default: 'rtl'
            }
        }
    }
</script>

<style scoped>


</style>